<div class="container">
  <div class="row">
    <div class="col-md-12">
      <p style="text-align: center;">confirmation is in progress...</p>
    </div>
  </div>
</div>
